<script setup>
import { translate } from '@/plugins/i18n.js'
import { useDisplay } from 'vuetify'

const { smAndDown } = useDisplay()
const props = defineProps({
  modelValue: Boolean,
  nutritionalData: Object
})

const emit = defineEmits(['update:modelValue'])

const closeDialog = () => {
  emit('update:modelValue', false)
}
</script>

<template>
  <VDialog
    :model-value="modelValue"
    @update:modelValue="(val) => emit('update:modelValue', val)"
    :fullscreen="smAndDown"
    :scrollable="smAndDown"
    max-width="500"
  >
    <VCard>
      <VCardTitle class="d-flex justify-space-between align-center">
        <span class="font-size-md-xl font-size-m">{{
          translate('pdp_subnav_nutritional_data')
        }}</span>
        <VBtn icon @click="closeDialog" variant="text">
          <VIcon>custom:close</VIcon>
        </VBtn>
      </VCardTitle>

      <VCardText class="pa-0 pa-md-3">
        <VTable
          class="w-100 upsell-nutritional-data-table"
          aria-describedby="upsell-nutritional-data"
        >
          <tbody class="font-size-md-m font-size-s">
            <tr v-if="nutritionalData?.ingredients">
              <th class="w-25 align-top" scope="row">
                {{ translate('fe_app_pdp_attribute_ingredients') }}
              </th>
              <td class="p-2 w-75">
                <span class="font-weight-normal">
                  {{ nutritionalData.ingredients }},
                </span>
                <span
                  v-if="nutritionalData?.contains_sulfide"
                  class="font-weight-bold"
                >
                  {{ translate('pdp_attribute_sulphites') }}
                </span>
              </td>
            </tr>

            <tr v-if="nutritionalData?.name">
              <td colspan="2">
                {{
                  translate('fe_app_opc_attribute_nutritional_value_headline')
                }}
              </td>
            </tr>

            <tr v-if="nutritionalData?.kj">
              <th scope="row">
                {{ translate('fe_app_pdp_attribute_item_energy') }}
              </th>
              <td>
                {{ nutritionalData.kj }} kj ({{ nutritionalData.kcal }} kcal)
              </td>
            </tr>

            <tr v-if="nutritionalData?.carbohydrates">
              <th scope="row">
                {{ translate('fe_app_pdp_attribute_item_carbs') }}
              </th>
              <td>{{ nutritionalData.carbohydrates }}g</td>
            </tr>

            <tr v-if="nutritionalData?.wine_sugar_grams">
              <th scope="row">
                {{ translate('fe_app_pdp_attribute_item_sugar') }}
              </th>
              <td>{{ nutritionalData.wine_sugar_grams }}g</td>
            </tr>

            <tr>
              <td colspan="2">
                {{ translate('fe_app_pdp_attribute_ingredients_disclaimer') }}
              </td>
            </tr>
          </tbody>
        </VTable>
      </VCardText>
    </VCard>
  </VDialog>
</template>

<style scoped>
.upsell-nutritional-data-table tr:not(:last-child) {
  border-bottom: 1px solid rgb(var(--v-theme-ash-gray));
}
.upsell-nutritional-data-table th:first-child,
.upsell-nutritional-data-table td:first-child {
  font-weight: bold;
  text-transform: uppercase;
  font-size: var(--s-font-size);
}
</style>
